import { HTMLAttributes, useEffect, useMemo } from "react";
import styles from "./index.less";
import { ModuleIOValueTypeEnum } from "@packages/flow-core/module";
import { Tooltip } from "antd";
import { FlowValueTypeMap } from "../../../constants/modules/dataType";
import { Handle, Position, useUpdateNodeInternals } from "reactflow";

export interface TargetHandleProps
  extends React.DetailedHTMLProps<
    HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  handleKey: string;
  valueType?: `${ModuleIOValueTypeEnum}`;
  moduleId: string;
}

export default function TargetHandle(props: TargetHandleProps) {
  const { handleKey, valueType, moduleId, ...rest } = props;

  const valType = valueType ?? ModuleIOValueTypeEnum.any;

  const valueStyle = useMemo(() => {
    return valueType && FlowValueTypeMap[valueType]
      ? FlowValueTypeMap[valueType]?.handlerStyle
      : FlowValueTypeMap[ModuleIOValueTypeEnum.any]?.handlerStyle;
  }, [valueType]);

  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    if (handleKey) {
      updateNodeInternals(moduleId);
    }
  }, [handleKey]);

  return (
    <div className={styles.container} {...rest}>
      <Tooltip
        title={
          <div>
            <div>{FlowValueTypeMap[valType]?.label}</div>
            {FlowValueTypeMap?.[valType]?.description && (
              <div>{FlowValueTypeMap?.[valType]?.description}</div>
            )}
          </div>
        }
      >
        <Handle
          style={{ width: 14, height: 14, ...valueStyle }}
          type="target"
          id={handleKey}
          position={Position.Left}
        />
      </Tooltip>
    </div>
  );
}
